import React from "react";
import {Container, Row, Col} from "react-bootstrap";

const Projects = () => {
	return (
		<>
			<Container fluid style={{marginTop: "15%", maxWidth: "1900px"}}>
				<Row>
					<Col sm={{span: 10, offset: 2}}>
						<h2>Projects.</h2>
					</Col>
				</Row>
				<Row>
					<Col
						sm={{span: 10, offset: 1}}
						lg={{span: 4, offset: 2}}
						style={{marginRight: "1%", marginBottom: "2.5%"}}
						className="d-flex justify-content-center align-items-center"
					>
						<div>
							<a href="https://food-picker-307400.uc.r.appspot.com/">
								<div className="tint-overlay hover-underline-animation">
									<h3 style={{padding: "5px"}}>Restaurant Finder</h3>
								</div>
							</a>

							<img
								className="image-grid"
								src="./Images/fp-website.png"
								alt="mayflower website"
							/>
						</div>
					</Col>
					<Col
						sm={{span: 10, offset: 1}}
						lg={{span: 4, offset: 0}}
						style={{marginRight: "1%", marginBottom: "2.5%"}}
						className="d-flex justify-content-center "
					>
						<a href="https://minimalist-clock-6e7a4.web.app/">
							<div className="tint-overlay hover-underline-animation">
								<h3>Minimalist Clock</h3>
							</div>
						</a>
						<img
							className="image-grid"
							src="./Images/mc-website.png"
							alt="mayflower website"
						/>
					</Col>
				</Row>
				<Row>
					<Col
						sm={{span: 10, offset: 1}}
						lg={{span: 4, offset: 2}}
						style={{marginRight: "1%", marginBottom: "2.5%"}}
						className="d-flex justify-content-center "
					>
						<div>
							<a href="https://github.com/l-kwok/CPP-Raytracer">
								<div className="tint-overlay hover-underline-animation">
									<h3 style={{padding: "5px"}}>C++ Raytracer</h3>
								</div>
							</a>

							<img
								className="image-grid"
								src="./Images/raytracer.png"
								alt="mayflower website"
							/>
						</div>
					</Col>
					<Col
						sm={{span: 10, offset: 1}}
						lg={{span: 4, offset: 0}}
						style={{marginRight: "1%", marginBottom: "2.5%"}}
						className="d-flex justify-content-center "
					>
						<a href="https://bornchinese.ca/">
							<div className="tint-overlay hover-underline-animation">
								<h3>Born Chinese</h3>
							</div>
						</a>
						<img
							className="image-grid"
							src="./Images/bc-website.png"
							alt="mayflower website"
						/>
					</Col>
				</Row>
				<Row className="d-flex flex-row justify-content-center">
					<Col className="d-flex justify-content-center ">
						<a
							href="https://github.com/l-kwok"
							target="_blank"
							rel="noreferrer"
						>
							Checkout my Github{" "}
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="16"
								height="16"
								fill="currentColor"
								class="bi bi-box-arrow-up-right"
								viewBox="0 0 16 16"
								style={{
									width: "25px;",
									height: "20px",
									marginBottom: "7px",
									stroke: "white",
									strokeWidth: "1.1px"
								}}
							>
								<path
									fill-rule="evenodd"
									d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
								/>
								<path
									fill-rule="evenodd"
									d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
								/>
							</svg>
						</a>
					</Col>
				</Row>
			</Container>
		</>
	);
};

export default Projects;
